import { tv } from 'tailwind-variants'

export const serverMaintenanceVariants = tv({
  slots: {
    container: 'flex w-full h-full flex-col justify-center items-center text-gray-500',
    serverUnderMaintenance: 'text-h1',
    maintenanceUnderProgress: 'text-h4',
    forAnyQuestionOpen: 'text-sm'
  }
})
